import React, { memo } from "react";
import { validators } from "investira.sdk";
import {
  Stack,
  CircularProgress,
  Typography,
} from "investira.react.components";
import EmpresasItem from "./EmpresasItem";

const ListEmpresasResultado = memo((props) => {
  const { isLoading, data, message, onClick, metrica } = props;

  return (
    <Stack>
      {!isLoading && !validators.isEmpty(data) && (
        <Stack id="empresas-list" sx={{ px: 0 }} component="ul">
          {data.map((xItem) => (
            <EmpresasItem
              key={xItem.pessoa_id || crypto.randomUUID()}
              data={xItem}
              onClick={(e) => onClick && onClick(e, xItem)}
              metrica={metrica}
            />
          ))}
        </Stack>
      )}

      {isLoading && (
        <Stack
          justifyContent="center"
          alignItems="center"
          flexGrow={1}
          sx={{ py: 2 }}
        >
          <CircularProgress size={24} />
        </Stack>
      )}

      {!isLoading && validators.isEmpty(data) && (
        <Stack
          justifyContent="center"
          alignItems="center"
          flexGrow={1}
          sx={{ py: 2 }}
        >
          <Typography variant="body2" color="textSecondary">
            {message || "Nenhuma empresa encontrada."}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
});

export default ListEmpresasResultado;
